import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=0aca1872&scoped=true&"
import script from "./Heatmap.vue?vue&type=script&lang=ts&"
export * from "./Heatmap.vue?vue&type=script&lang=ts&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=0aca1872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca1872",
  null
  
)

export default component.exports
import {QLayout,QBtn,QMenu,QPageContainer} from 'quasar'
component.options.components = Object.assign({QLayout,QBtn,QMenu,QPageContainer}, component.options.components || {})
